import React from "react"
import Layout from "../components/layout"
import { motion } from "framer-motion"

import NavBar from "../components/NavBar"

import FooterSection from "../sections/footer-section"

import { theme } from "../theme/theme"

const WeCarePage = () => {
  const [weCareSelected, setWeCareSelected] = React.useState("eco-friendly")

  const variants = {
    selected: { color: theme.colors.secondary, cursor: "pointer" },
    notSelected: { color: theme.colors.grey0, cursor: "pointer" },
  }

  const description = {
    selected: { opacity: 1, display: "block" },
    notSelected: { opacity: 0, display: "none" },
  }

  return (
    <Layout>
      <motion.div style={{ height: "100vh" }}>
        <NavBar />
        <motion.div
          id={"we-care-description"}
          style={{
            margin: 0,
            paddingTop: 50,
            paddingLeft: "10%",
            paddingRight: "10%",
            display: "flex",
            justifyContent: "start",
            flexWrap: "wrap",
            height: "auto",
            width: "100%",
          }}
        >
          <h1>We Care</h1>

          <p>
            Brand New Labels present you the upcoming labels of today and
            tomorrow. Some of them fully embrace sustainability on many
            different levels, while others are crawling their way up step by
            step.
          </p>
          <p>
            <b>Sustainability is kind of a broad term.</b> So to make it
            manageable, we differentiate 5 categories in which a fashion brand
            can be sustainable. We make sure that all labels who join our club
            embrace at least one out of five categories of sustainability. We
            believe that we can make a difference as long as we can help,
            inspire and motivate each other.
          </p>
        </motion.div>
        <motion.div
          id={"we-care-sustainbilty"}
          style={{
            margin: 0,
            paddingTop: 50,
            paddingLeft: "10%",
            paddingRight: "10%",
            display: "flex",
            justifyContent: "start",
            flexWrap: "wrap",
            height: "auto",
            width: "100%",
          }}
        >
          <motion.h1
            className={"we-care-item"}
            variants={variants}
            initial={"selected"}
            animate={
              weCareSelected === "eco-friendly" ? "selected" : "notSelected"
            }
            onClick={() => {
              setWeCareSelected("eco-friendly")
            }}
          >
            Eco Friendly
          </motion.h1>
          <motion.h1 style={{ color: theme.colors.grey0 }}>/</motion.h1>
          <motion.h1
            className={"we-care-item"}
            variants={variants}
            initial={"notSelected"}
            animate={weCareSelected === "social" ? "selected" : "notSelected"}
            onClick={() => {
              setWeCareSelected("social")
            }}
          >
            Social
          </motion.h1>
          <motion.h1 style={{ color: theme.colors.grey0 }}>/</motion.h1>
          <motion.h1
            className={"we-care-item"}
            variants={variants}
            initial={"notSelected"}
            animate={weCareSelected === "vegan" ? "selected" : "notSelected"}
            onClick={() => {
              setWeCareSelected("vegan")
            }}
          >
            Vegan
          </motion.h1>
          <motion.h1 style={{ color: theme.colors.grey0 }}>/</motion.h1>
          <motion.h1
            className={"we-care-item"}
            variants={variants}
            initial={"notSelected"}
            animate={
              weCareSelected === "fair-trade" ? "selected" : "notSelected"
            }
            onClick={() => {
              setWeCareSelected("fair-trade")
            }}
          >
            Fair Trade
          </motion.h1>
          <motion.h1 style={{ color: theme.colors.grey0 }}>/</motion.h1>
          <motion.h1
            className={"we-care-item"}
            variants={variants}
            initial={"notSelected"}
            animate={
              weCareSelected === "locally-made" ? "selected" : "notSelected"
            }
            onClick={() => {
              setWeCareSelected("locally-made")
            }}
          >
            Locally Made
          </motion.h1>
          <motion.div
            id={"sustainability-descriptions"}
            style={{ height: 400 }}
          >
            <motion.div
              id={"eco-friendly-description"}
              variants={description}
              initial={"selcted"}
              animate={
                weCareSelected === "eco-friendly" ? "selected" : "notSelected"
              }
            >
              <p>
                When we talk about eco-friendly clothing, we are talking about
                those companies who inflict minimal or no harm to the
                environment. Apart from second-handed clothes, there is really
                no such thing as a 100% eco-friendly piece of clothing. This is
                because all clothing takes water (to grow the fibre which makes
                the fabric) and energy (to make the fabric and the garment).
              </p>

              <p>
                Clothing can be eco friendly in different kind of ways. In our
                opinion eco-friendly clothes means:
                <ul style={{ paddingTop: 10 }}>
                  <li>
                    Using fibres which are not grown or produced with damaging
                    chemicals
                  </li>
                  <li>Ensure that no toxins have entered the environment</li>
                  <li>
                    Using fabrics that use small amounts of precious water to
                    grow, such as bamboo, tencel or organic cotton, hemp or
                    linen.
                  </li>
                  <li>Reduce CO2 emissions as much as possible.</li>
                </ul>
              </p>
            </motion.div>
            <motion.div
              id={"social-description"}
              variants={description}
              animate={weCareSelected === "social" ? "selected" : "notSelected"}
              onClick={() => {
                setWeCareSelected("social")
              }}
            >
              <p>
                These loving brands who are awarded with our social label, are
                going a step further to help people and the environment. For
                example, they support charities and local projects by donating
                part of the profit or support underpriveledge groups.
              </p>
            </motion.div>
            <motion.div
              id={"vegan-description"}
              variants={description}
              initial={"notSelected"}
              animate={weCareSelected === "vegan" ? "selected" : "notSelected"}
            >
              <p>
                We talk about vegan clothing when the garment doesn’t contain
                any animal products and when no animal additives have been used
                during the production process.
              </p>
              <p>
                Many clothing is made from animal materials such as wool,
                leather, suede, fur, felt, feathers, silk or are dyed and glued
                with materials of animal origin. Since many animals emit CO2,
                the production of vegan clothing is therefore also more
                environmentally friendly.
              </p>
            </motion.div>
            <motion.div
              id={"fair-trade-description"}
              variants={description}
              initial={"notSelected"}
              animate={
                weCareSelected === "fair-trade" ? "selected" : "notSelected"
              }
            >
              <p>
                When buying fair trade clothing you protect the farmers and
                workers against exploitation. Which brings forced labor or child
                labor out of the question. If something is labeled as fair trade
                it means that the employees work under safe and hygienic working
                conditions. In fair trade, workers are treated fairly and
                receive a fair and viable wage.
              </p>
            </motion.div>
            <motion.div
              id={"locally-made-description"}
              variants={description}
              initial={"notSelected"}
              animate={
                weCareSelected === "locally-made" ? "selected" : "notSelected"
              }
            >
              <p>
                At Brand New Labels our labels gets the ‘locally made’ stamp
                when the clothing is produced in Europe. Why does this make us
                happy?
              </p>

              <p>
                Firstly, because the clothing has to travel a smaller distance
                to arrive at you. In addition, clothing produced in Europe is
                subject to European regulations. This clothing is often produced
                in a more sustainable way than outside of Europe, as the
                factories have to comply with certain environmental regulations.
                But we have to stay sharp, as this is not a guarantee for fair
                and environmentally friendly production.
              </p>
            </motion.div>
          </motion.div>
        </motion.div>
        <FooterSection />
      </motion.div>
    </Layout>
  )
}

export default WeCarePage
